import { message } from "antd";
import axios from "axios"
import dayjs from "dayjs"
import { useCallback, useEffect } from "react";
import { useState } from "react";
export const isFunction = (value) => typeof value === 'function';

export const useSetState = (initialState) => {
    const [state, setState] = useState(initialState);
  
    const setMergeState = useCallback((patch) => {
      setState((prevState) => {
        const newState = isFunction(patch) ? patch(prevState) : patch;
        return newState ? { ...prevState, ...newState } : prevState;
      });
    }, []);
  
    return [state, setMergeState, setState];
  }
export const getFormData = ({
    constant,
    filter_cond = {},
    page = 1,
    page_size = 10,
    sort,
    noAuth,
    with_extend_data,
  }) => {
    return new Promise((resolve, reject) => {
      if (constant.needPerms && !noAuth) {
        axios
          .post(`/api/tview/data/${constant.classId}/list`, {
              page: page,
              page_size: page_size,
              filter_cond: filter_cond,
              sort:'updated_at desc'
          })
          .then((res) => {
            if (res.ret === 0) {
              resolve(res.msg || {})
            } else {
              resolve({})
            }
          })
      } else {
        axios
       .post(`/api/tview/data/${constant.classId}/list`, {
              page: page,
              page_size: page_size,
              filter_cond: filter_cond,
              sort:'updated_at desc'

          })
          .then((res) => {
            if (res.ret === 0) {
              resolve(res.msg || {})
            } else {
              resolve({})
            }
          })
      }
    })
  }
export const uploadfileChange = (e) => {
  console.log('上传file', e);
  const {file} =e
  if (file.status === 'uploading') {
    const maxSize = 100 * 1024 * 1024; // 100MB
    if (file.size > maxSize) {
      message.error(`${file.name} 超过大小限制（100MB）`);
      file.status = 'error'; // 手动标记为错误状态
    }
  }else if (file.status=='done'){
    let fileList = [...e.fileList];
    fileList = fileList.map((file) => {
      if (file.response) {
        (file.url = file.response.msg.url),
          (file.thumbUrl = file.isUploaded ? file.uploadedUrl : file.response.msg.url);
          (file.create_at = dayjs().valueOf());
      }
    });
  }
 
};
  export const addItem = async ({classId, values,id}) => {
    if(id){
      return axios.post(`/api/tview/data/${classId}/update`, {
          id,
          values: values,
      });
    }else{
      return axios.post(`/api/tview/data/${classId}/add`, {
           values,
      });
    }

  };
  //集成对象形成filter_数组
  export const  transformConditions=(obj,timeFieldKeys=[],numFieldKeys=[])=>{
    console.log(timeFieldKeys,obj,'timeFieldKeys');
    // 创建结果数组
    // const conditions=[]
    let conditions = {
      op:'and',
      filters:[]
    };
    // 遍历对象的所有键
      Object.keys(obj).forEach(key => {
      // 排除current和pageSize
      // console.log(key,);
        console.log(timeFieldKeys,key,timeFieldKeys.includes(key),'timeFieldKeys');

      
      if (key !== 'current' && key !== 'pageSize') {
        
        if(timeFieldKeys.includes(key)){
                 conditions.filters.push({
            field: key,
            op: 'between',  // 这里使用like作为默认操作符
            value: [dayjs(obj[key]).startOf('day').valueOf(),dayjs(obj[key]).endOf('day').valueOf()]
        });
        } else if (numFieldKeys.includes(key)){
                 conditions.filters.push({
            field: key,
            op: 'between',  // 这里使用like作为默认操作符
            value: obj[key]
        });
        }else{
            conditions.filters.push({
            field: key,
            op: 'like',  // 这里使用like作为默认操作符
            value: obj[key]
        });
        }
       
      }
    });
    console.log(conditions,'conditions');
    
    
    return conditions;
  }
  // 删除数据
export const deleteItem = async ({classId, itemId}) => {
  return axios.post(`/api/tview/data/${classId}/delete?id=${itemId}`, {
      id: itemId,
  });
};
export function isEmptyValues(value) {
  return (
    value === undefined ||
    value === null ||
    value === NaN ||
    (Array.isArray(value) && value.includes('')) ||
    (typeof value === 'object' && Object.keys(value).length === 0) ||
    (typeof value === 'string' && value === '')
  );
}
export const useStoreFormInfo = (classId) => {
  const [formInfo, setFormInfo] = useState({});
  useEffect(() => {
    axios(`/backend/api/forms/classes/get`, {
      params: {
        key: classId,
      },
    })
      .then((res) => {
        setFormInfo(res?.msg)
      });
  }, []);
  return [formInfo, setFormInfo];
};
export const useFormInfo = (classId) => {
  const [formInfo, setFormInfo] = useState({});
  
  useEffect(() => {
    if(classId){
  axios(`/api/tview/form/table/get`, {
      params: {
        key: classId,
      },
    })
      .then((res) => {
        console.log(res,'rres');
        
        setFormInfo(res?.msg)
      });
    }
  
  }, [classId]);
  return [formInfo, setFormInfo];
};

export const useProjectUnitOptions = (refresh) => {
  const [options, setOptions] = useState([]);
  useEffect(() => {
    axios
      .post(`/backend/api/forms/items/1758168291596/list_withoutperm`, {
        page:1,
        page_size:999,
      })
      .then((res) => {
        let storeOptions =res.msg?.data?.map((e)=>{
          return {
            ...e,
            label:e?.['f_unit_name'],
            value:e?.['f_unit_name']
          }
        })
        setOptions(storeOptions|| []);
      });
  }, [refresh]);
  return [options, setOptions];
  
};
export const departmentOptions = (refresh) => {
  const [options, setOptions] = useState([]);
  useEffect(() => {
    axios
      .get(`/api/tview/superadmin/data/department/list`, {
      params:{
        page:1,
        page_size:999,
      }
      })
      .then((res) => {
        let storeOptions =res.msg?.rows?.map((e)=>{
          return {
            ...e,
            label:e?.['name'],
            value:e?.['id']
          }
        })
        setOptions(storeOptions|| []);
      });
  }, [refresh]);
  return [options, setOptions];
  
};
export const useProjectOptions = () => {
  const [projectOptions, setProjectOptions] = useState([]);
  useEffect(() => {
    axios
      .post(`/backend/api/forms/items/1758168572409/list_withoutperm`, {
        page:1,
        page_size:999,
      })
      .then((res) => {
        let storeOptions =res.msg?.data?.map((e)=>{
          return {
            ...e,
            label:e?.['f_pro_name'],
            value:e?.['f_pro_name']
          }
        })
        setProjectOptions(storeOptions|| []);
      });
  }, []);
  return [projectOptions, setProjectOptions];
  
};
export const projectUserOptions = () => {
  const [userOptions, setUserOptions] = useState([]);
  useEffect(() => {
    axios
      .get(`/api/tview/data/users/list`, {
       params:{
         page:1,
        page_size:999,
       }
      })
      .then((res) => {
        let options =res.msg?.rows?.map((e)=>{
          return {
            ...e,
            label:e?.['nickname'],
            value:e?.['id']
          }
        })
        setUserOptions(options|| []);
      });
  }, []);
  return [userOptions, setUserOptions];
  
};
export const projetTypeOptions = [
  {
    label:'其他',
    value:'其他',
  },
  {
    value: '装饰装修工程',
    label: '装饰装修工程',
    children: [
      { value: '装饰装修工程-其他', label: '其他'},
      { value: '装饰装修工程-室内精装修工程', label: '室内精装修工程'},
      { value: '装饰装修工程-室外精装修工程', label: '室外精装修工程'},
    ]
  },
  {
    value: '土建工程',
    label: '土建工程',
    children: [
      { value: '土建工程-前期工程', label: '前期工程'},
      { value: '土建工程-地基基础工程', label: '地基基础工程'},
      { value: '土建工程-屋面工程', label: '屋面工程'},
      { value: '土建工程-其他', label: '其他'},
      { value: '土建工程-主体结构工程', label: '主体结构工程'},
      { value: '土建工程-土石方工程', label: '土石方工程'},
    ]
  },
  {
    value: '金属结构制作及安装',
    label: '金属结构制作及安装',
    children: [
      { value: '金属结构制作及安装-膜结构制作安装', label: '膜结构制作安装'},
      { value: '金属结构制作及安装-起重设备拆装', label: '起重设备拆装'},
      { value: '金属结构制作及安装-钢结构制作安装', label: '钢结构制作安装'},
    ]
  },
  {
    value: '安装工程',
    label: '安装工程',
    children: [
      { value: '安装工程-通风工程', label: '通风工程'},
      { value: '安装工程-其他', label: '其他'},
      { value: '安装工程-电气工程', label: '电气工程'},
      { value: '安装工程-化工', label: '化工'},
      { value: '安装工程-管道工程', label: '管道工程'},
    ]
  },
  {
    value: '市政工程',
    label: '市政工程',
    children: [
      { value: '市政工程-其他', label: '其他'},
      { value: '市政工程-道路', label: '道路'},
      { value: '市政工程-隧道', label: '隧道'},
      { value: '市政工程-通道', label: '通道'},
      { value: '市政工程-桥梁', label: '桥梁'},
    ]
  },
  {
    value: '园林环境工程',
    label: '园林环境工程',
    children: [
      { value: '园林环境工程-土壤污染治理', label: '土壤污染治理'},
      { value: '园林环境工程-水环境治理', label: '水环境治理'},
      { value: '园林环境工程-生活基础设施绿化', label: '生活基础设施绿化'},
      { value: '园林环境工程-房产绿化', label: '房产绿化'},
      { value: '园林环境工程-公园绿地', label: '公园绿地'},
      { value: '园林环境工程-公共设施绿化', label: '公共设施绿化'},
      { value: '园林环境工程-城市交通绿化', label: '城市交通绿化'},
    ]
  },
];

//获取统计表单
export const getGroupstaticData = async ({classId,chart_typ, class_typ,filter_cond=[],static_fields=[],widget_permission='',group_fields_x=[]}) => {

    return axios.post(`/backend/api/forms/items/${classId}/groupstatic`, {
        chart_typ,
        class_typ,
        widget_permission,
        static_fields,
        filter_cond,
        group_fields_x,
    });

};
export const getTableKeyOptions = (tableKey, key, filters = []) => {
  console.log(filters,'filters');
  
  const [tableOptions, setTableOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // 1. 修正：请求函数内部先定义取消函数，再异步请求
  const fetchTableOptions = useCallback(() => {
    if (!tableKey) {
      // 空tableKey返回空函数，避免后续报错
      return () => {};
    }

    setLoading(true);
    setError(null);
    const source = axios.CancelToken.source();
    let isCanceled = false;

    // 异步请求逻辑
    const fetchData = async () => {
      try {
        if (isCanceled) return;
        const res = await axios.post(
          `/api/tview/data/${tableKey}/list`,
          {
            page: 1,
            page_size: 999,
            filter_cond: { op: "and", filters },
          },
          { cancelToken: source.token }
        );

        if (isCanceled) return; // 取消后不再更新状态
        if (res.ret === 0) {
          const uniqueMap = new Map();
          (res.msg?.rows || []).forEach((e) => {
            const label = e?.[key];
            if (label && !uniqueMap.has(label)) {
              uniqueMap.set(label, {
                ...e,
                oriValue: e?.value,
                oriLabel: e?.label,
                key: e?.id,
                label,
                value: label,
              });
            }
          });
          setTableOptions(Array.from(uniqueMap.values()));
        }
      } catch (err) {
        if (isCanceled) return;
        // 忽略取消请求的错误
        if (!axios.isCancel(err)) {
          setError(err.message || '获取数据失败');
          console.error('请求表格选项失败：', err);
        }
      } finally {
        if (isCanceled) return;
        setLoading(false);
      }
    };

    // 立即执行异步请求
    fetchData();

    // 2. 关键：同步返回取消函数（而非Promise）
    return () => {
      isCanceled = true; // 标记为已取消，避免后续状态更新
      source.cancel('请求已取消');
    };
  }, [tableKey, key, JSON.stringify(filters)]);

  // 3. 修正useEffect中的取消逻辑
  useEffect(() => {
    const cancelRequest = fetchTableOptions(); // 此时拿到的是真正的取消函数
    // 组件卸载/依赖变更时执行取消
    return () => cancelRequest();
  }, [fetchTableOptions]);

  return [tableOptions];
};

 export const replacePathSegment = (path, segmentIndex, newSegment) => {
  // 拆分路径为数组（过滤空字符串，处理首尾/连续斜杠）
  const segments = path.split('/').filter(seg => seg);
  // 校验索引合法性
  if (segmentIndex < 0 || segmentIndex >= segments.length) {
    console.warn('路径段索引超出范围');
    return path;
  }
  // 替换目标段并重新拼接
  segments[segmentIndex] = newSegment;
  return `/${segments.join('/')}`;
};